import React, { useState } from 'react';
import '../../../../Stylesheets/Dashboard/Other/HowToUse.css';
import { motion, AnimatePresence } from 'framer-motion';

import create_project from '../../../../assets/illustration/create-project-image.png'
import add_workers from '../../../../assets/illustration/add-worker-image.png'
import add_material from '../../../../assets/illustration/add-material-image.png'
import log_expenses from '../../../../assets/illustration/log-expense-image.png'
import view_reports from '../../../../assets/illustration/view-reports-image.png'

const steps = [
  {
    title: 'Create Project',
    desc: 'Start by creating your construction site project with basic details like location, duration, and site type.',
    image: create_project,
  },
  {
    title: 'Add Workers',
    desc: 'Add your workers, assign roles, and begin tracking attendance and payments.',
    image: add_workers,
  },
  {
    title: 'Manage Materials',
    desc: 'Track incoming materials, usage, and bills with automatic low stock alerts.',
    image: add_material,
  },
  {
    title: 'Log Expenses',
    desc: 'Log site level expenses and attach bills — keep financial records clean and export-ready.',
    image: log_expenses,
  },
  {
    title: 'View Reports',
    desc: 'Monitor everything with dynamic dashboards and generate downloadable reports.',
    image: view_reports,
  },
];

const animationVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

const HowToUse = () => {
  const [step, setStep] = useState(0);

  const handleNext = () => {
    if (step < steps.length) setStep(step + 1);
  };

  const handleRestart = () => setStep(0);

  return (
    <div className="howto-container">
      <AnimatePresence mode="wait">
        {step === steps.length ? (
          <motion.div
            key="done"
            initial="initial"
            animate="animate"
            exit="exit"
            variants={animationVariants}
            transition={{ duration: 0.5 }}
          >
            <h1 className="hurray-text">🎉 Hurray! You now know how to use Site360!</h1>
            <p>Start managing your site like a pro today.</p>
            <button className="primary-btn" onClick={handleRestart}>Restart Guide</button>
          </motion.div>
        ) : (
          <motion.div
            key={step}
            initial="initial"
            animate="animate"
            exit="exit"
            variants={animationVariants}
            transition={{ duration: 0.5 }}
          >
            <h1 className="step-title">Step {step + 1}: {steps[step].title}</h1>
            <div className="step-content">
              <img src={steps[step].image} alt={steps[step].title} className="step-image" />
              <p className="step-desc">{steps[step].desc}</p>
            </div>
            <button className="primary-btn" onClick={handleNext}>
              {step === steps.length - 1 ? 'Finish' : 'Next →'}
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default HowToUse;